import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import { getModuleDescriptions } from '../data/module-descriptions';

/**
 * useModuleDescriptions — queue #656 §R656-2.
 *
 * `data/module-descriptions.{ko,en}.tsx` are each ~1300 lines of rich JSX, so they are
 * loaded lazily per i18n.language via `getModuleDescriptions()` (dynamic import + module
 * scope cache — one fetch per locale). Before the first resolve for a given locale this
 * returns `{}`, so `ModuleDetailBody` falls back to the existing `LearningHints` default
 * for that short tick — no separate loading spinner needed (5-state default unchanged).
 */
export function useModuleDescriptions(): Record<string, ReactNode> {
  const { i18n } = useTranslation();
  const lang = i18n?.language ?? 'ko';
  const [descriptions, setDescriptions] = useState<Record<string, ReactNode>>({});

  useEffect(() => {
    let cancelled = false;
    getModuleDescriptions(lang).then((map) => {
      if (!cancelled) setDescriptions(map);
    });
    return () => {
      cancelled = true;
    };
  }, [lang]);

  return descriptions;
}
